import React from "react";
import { Switch, Route } from "react-router-dom";

import OrderArchivesPage from "./OrderArchivesPage";
import OrderArchivePage from "./OrderArchivePage";

const OrderArchives = () => (
  <Switch>
    <Route path="/dispatch/order-archive/:id">
      <OrderArchivePage />
    </Route>
    <Route path="/dispatch/order-archive">
      <OrderArchivesPage />
    </Route>
  </Switch>
);

export default OrderArchives;
